import { gql } from '@apollo/client/core'


export const MAIL_TAG_SHEET = gql`
  query mailTagSheet($domiciliationId: ID!) {
    mailTagSheet(domiciliationId: $domiciliationId)
  }
`

export interface MailTagSheetVariables {
  domiciliationId: number
}

export interface MailTagSheetResult {
  mailTagSheet: string
}


export const CUSTOMER_ZIP = gql`
  query customerZip($domiciliationId: ID!, $generateZip: Boolean!) {
    customerZip(domiciliationId: $domiciliationId, generateZip: $generateZip)
  }
`

export interface CustomerZipVariables {
  domiciliationId: number,
  generateZip: boolean
}

export interface CustomerZipResult {
  customerZip: string,
  error?: any
}

export const POSTAL_PROCURATION_PDF = gql`
  query postalProcurationPdf($domiciliationId: ID!, $uuid: String) {
    postalProcurationPdf(domiciliationId: $domiciliationId, uuid: $uuid) {
      url
      uuid
    }
  }
`

export interface PostalProcurationVariables {
  domiciliationId: number,
  uuid?: string | null
}

interface PostalProcurationPdfWithUuid {
  uuid?: string,
  url?: string
}

export interface PostalProcurationResult {
  postalProcurationPdf: PostalProcurationPdfWithUuid,
  error?: any
}

